const features = [
  {
    icon: 'ri-4k-line',
    title: '超清画质 · 秒开不缓冲',
    desc: '全站高清电影、高清电视剧均采用4K超清画质编码，智能CDN加速确保不缓冲秒开，每一帧都清晰流畅。',
  },
  {
    icon: 'ri-play-list-2-line',
    title: '全集播放 · 无需等待',
    desc: '热门剧集一次性上线全集，无需追更等待。支持断点续播、倍速播放，自由掌控观影节奏。',
  },
  {
    icon: 'ri-device-line',
    title: '全端适配 · 随开随看',
    desc: '桌面、平板、手机全设备完美适配，无需下载App也能在移动端畅享超清观影体验，随时随地打开即看。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">平台优势</h2>
          <p className="mt-2 text-sm text-foreground-500">为什么千万影迷选择老子影视网</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {features.map((f) => (
            <div
              key={f.title}
              className="p-6 rounded-lg bg-background-100 border border-background-200/60 hover:border-accent-300/50 transition-colors"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 mb-4">
                <i className={`${f.icon} text-lg text-accent-600`}></i>
              </div>
              <h3 className="text-sm md:text-base font-medium text-foreground-800 mb-2">{f.title}</h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}